import { render, staticRenderFns } from "./videoFilePreview.vue?vue&type=template&id=040ec2fa"
import script from "./videoFilePreview.vue?vue&type=script&lang=js"
export * from "./videoFilePreview.vue?vue&type=script&lang=js"
import style0 from "./videoFilePreview.vue?vue&type=style&index=0&id=040ec2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports